module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.linker
    }
  }, [_c('section', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mail-list-item"
  }, [_c('h4', {
    staticClass: "title is-4",
    class: {
      notRead: !_vm.read, hasRead: _vm.read
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inscribe"
  }, [_c('span', {
    staticClass: "is-pulled-left"
  }, [_vm._v("from  " + _vm._s(_vm.sender))]), _vm._v("\n         \n        "), _c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(_vm.time))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd6451bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MailItem.vue
// module id = 256
// module chunks = 1